module.exports = __webpack_public_path__ + "img/FasterHealing.24b73838.png";